import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  ru: {
    // Header
    about: 'О компании',
    services: 'Услуги',
    howWeWork: 'Как работаем',
    testimonials: 'Отзывы',
    faq: 'FAQ',
    getConsultation: 'Получить консультацию',
    
    // Hero
    heroBadge: '15+ лет защищаем финансовые интересы клиентов по всему миру',
    heroTitle: 'Возвращаем ваши средства от мошенников и недобросовестных брокеров',
    heroDescription: 'Capitara — ведущая международная финансовая компания с глобальным присутствием. Мы специализируемся на возврате средств через банковские процедуры от мошенников, недобросовестных брокеров и инвестиционных пирамид. Наша команда экспертов с 15-летним опытом успешно возвращает деньги клиентам в Европе, Азии, Америке, на Ближнем Востоке и Африке. Успешность 87%. Оплата только за результат.',
    freeConsultation: 'Бесплатная консультация',
    ourServices: 'Наши услуги',
    returnedToClients: 'Возвращено клиентам',
    successfulCases: 'Успешных кейсов',
    countriesWorld: 'Стран мира',
    
    // About
    aboutTitle: 'О компании Capitara',
    aboutSubtitle: 'Международная финансовая компания — возврат средств через банковские процедуры',
    whoWeAre: 'Кто мы',
    aboutText1: 'Capitara — ведущая международная финансовая компания, специализирующаяся на возврате средств через банковские процедуры от мошенников, недобросовестных брокеров и инвестиционных пирамид. Наша команда экспертов с 15-летним опытом успешно возвращает деньги клиентам по всему миру.',
    aboutText2: 'Мы работаем на всех континентах, помогая жертвам финансового мошенничества независимо от их местонахождения. Наша миссия — защитить права инвесторов и вернуть то, что принадлежит им по праву, используя банковские процедуры и работу с финансовыми регуляторами. Каждый клиент получает персональное сопровождение на родном языке с учетом локальных особенностей банковского регулирования и культурных традиций. Мы понимаем, что финансовые потери — это не только материальный ущерб, но и эмоциональный стресс, поэтому обеспечиваем полную конфиденциальность и профессиональную поддержку на каждом этапе.',
    globalPresence: 'Глобальное присутствие',
    globalPresenceText: 'Работаем с банками и финансовыми регуляторами по всему миру. Возвращаем средства через банковские процедуры независимо от географии на всех континентах.',
    regionalExpertise: 'Региональная экспертиза',
    regionalExpertiseText: 'Специализированные команды для каждого региона мира с глубоким знанием локального банковского регулирования и бизнес-практик.',
    multiculturalTeam: 'Мультикультурная команда',
    multiculturalTeamText: '50+ специалистов по банковским процедурам и финансовых аналитиков из разных стран с опытом в международных банковских операциях, fintech и различных финансовых системах.',
    multiJurisdiction: 'Опыт работы с банками разных стран',
    multiJurisdictionText: 'Работаем с банковскими системами разных стран: европейскими, азиатскими, ближневосточными и международными финансовыми институтами.',
    individualApproach: 'Индивидуальный подход',
    individualApproachText: 'Каждый кейс уникален. Разрабатываем персональную стратегию с учетом культурных, банковских и финансовых особенностей региона клиента.',
    provenReputation: 'Проверенная репутация',
    provenReputationText: '15 лет на международном рынке, 2000+ успешных кейсов, $10.4M+ возвращено, положительные отзывы от клиентов со всех континентов.',
    
    // Services
    servicesTitle: 'Наши услуги',
    servicesSubtitle: 'Комплексные решения для возврата ваших средств',
    brokerRecovery: 'Возврат средств от брокеров',
    brokerRecoveryDesc: 'Возврат депозитов от нелицензированных и недобросовестных форекс и криптовалютных брокеров',
    cryptoFraud: 'Борьба с криптомошенниками',
    cryptoFraudDesc: 'Возврат средств, похищенных через поддельные криптовалютные платформы и пирамиды',
    investmentDisputes: 'Инвестиционные споры',
    investmentDisputesDesc: 'Разрешение споров с инвестиционными фондами и управляющими компаниями',
    pyramidRecovery: 'Возврат из финансовых пирамид',
    pyramidRecoveryDesc: 'Помощь жертвам финансовых пирамид и MLM-схем в возврате вложенных средств',
    learnMore: 'Подробнее',
    
    // Calculator
    calculatorBadge: 'Бесплатная оценка',
    calculatorTitle: 'Калькулятор возврата средств',
    calculatorSubtitle: 'Оцените вероятность и сумму возврата ваших средств за 30 секунд',
    lostAmount: 'Сумма потерянных средств',
    fraudType: 'Тип мошенничества',
    forexBroker: 'Форекс/CFD брокер',
    cryptoScam: 'Криптомошенничество',
    pyramid: 'Финансовая пирамида',
    investmentFund: 'Инвестиционный фонд',
    other: 'Другое',
    whenHappened: 'Когда это произошло?',
    lessThanWeek: 'Менее недели',
    upToMonth: 'До 1 месяца',
    oneToThreeMonths: '1-3 месяца',
    threeToSixMonths: '3-6 месяцев',
    // Modal
    minAmount: 'Мин. сумма',
    whatWeHandle: 'Что мы решаем',
    sixToTwelveMonths: '6-12 месяцев',
    moreThanYear: 'Более года',
    hasDocuments: 'Есть документы/переписка?',
    yesHave: 'Да, есть',
    noPartial: 'Нет / Частично',
    calculate: 'Рассчитать возврат',
    calculating: 'Рассчитываем...',
    resultsTitle: 'Результаты оценки',
    preliminaryCalc: 'Предварительный расчёт',
    successProbability: 'Вероятность успеха',
    expectedReturn: 'Ожидаемый возврат',
    returnPeriod: 'Срок возврата',
    months: 'месяцев',
    weeks: 'нед.',
    exactConditions: 'Точные условия определяются после бесплатной консультации с экспертом',
    getFreeConsultation: 'Получить бесплатную консультацию',
    
    // Offices
    officesBadge: 'Глобальное присутствие',
    officesTitle: 'Наши офисы по всему миру',
    officesSubtitle: 'Мы представлены на 4 континентах для максимально эффективной работы с вашим делом',
    asia: 'Азия',
    middleEast: 'Ближний Восток',
    europe: 'Европа',
    northAmerica: 'Северная Америка',
    southAsia: 'Южная Азия',
    offices: 'Офисов',
    continents: 'Континента',
    countriesCoverage: 'Стран охвата',
    support247: 'Поддержка',
    
    // Contact
    contactTitle: 'Получите бесплатную консультацию',
    contactSubtitle: 'Оставьте заявку или свяжитесь с нами в Telegram',
    yourName: 'Имя',
    yourNamePlaceholder: 'Ваше имя',
    phone: 'Телефон',
    email: 'Email',
    telegram: 'Telegram',
    lossAmount: 'Сумма убытка (приблизительно)',
    describeYourSituation: 'Опишите вашу ситуацию',
    describePlaceholder: 'Кратко опишите, что произошло: когда, с какой компанией, какая сумма...',
    sendRequest: 'Отправить заявку',
    sending: 'Отправка...',
    contactViaTelegram: 'Свяжитесь через Telegram',
    telegramDesc: 'Получите быстрый ответ от наших экспертов в течение 15 минут. Конфиденциально и удобно.',
    openTelegram: 'Открыть Telegram',
    workSchedule: 'Режим работы',
    internationalWork: 'Международная работа 24/7',
    consultation: 'Консультация',
    firstConsultationFree: 'Первая консультация бесплатно',
    
    // FAQ
    faqTitle: 'Часто задаваемые вопросы',
    faqSubtitle: 'Ответы на популярные вопросы о наших услугах',
    faqQ1: 'Какова вероятность возврата средств?',
    faqA1: 'Вероятность зависит от конкретной ситуации. В среднем мы успешно возвращаем средства в 87% случаев. После бесплатной консультации мы сможем дать точную оценку ваших шансов.',
    faqQ2: 'Сколько времени занимает процесс возврата?',
    faqA2: 'Сроки варьируются от 1 недели до 1 месяца в зависимости от сложности дела, банковской системы страны и готовности банка к сотрудничеству. Мы всегда информируем о прогрессе на каждом этапе.',
    faqQ3: 'Какие документы необходимы для начала работы?',
    faqA3: 'Для оценки ситуации нужны: договоры с брокером/компанией, подтверждения транзакций, переписка, скриншоты платформы. Мы поможем собрать все необходимые доказательства.',
    faqQ4: 'Как формируется стоимость услуг?',
    faqA4: 'Мы работаем по модели «успех-fee» — оплата только при успешном возврате средств. Комиссия составляет 4-15% от возвращенной суммы в зависимости от сложности дела.',
    
    // Footer
    footerDesc: 'Профессиональный возврат средств от мошенников и недобросовестных брокеров. 15+ лет опыта, 87% успешность. Работаем на 4 континентах.',
    company: 'Компания',
    contacts: 'Контакты',
    ourOffices: 'Наши офисы',
    allRightsReserved: 'Все права защищены.',
    privacyPolicy: 'Политика конфиденциальности',
    termsOfUse: 'Условия использования',
    returnCalculator: 'Калькулятор возврата',

    // Lead Form Page
    formTitle: 'Получить консультацию',
    formSubtitle: 'Заполните форму и мы свяжемся с вами в ближайшее время',
    formStepName: 'Как вас зовут?',
    formStepNamePlaceholder: 'Ваше полное имя (ФИО)',
    formStepContacts: 'Контактные данные',
    formStepFraud: 'Вид мошенничества',
    formStepFraudDesc: 'Выберите тип мошенничества, с которым вы столкнулись',
    formFraudInvestment: 'Инвестиции',
    formFraudPyramid: 'Пирамиды',
    formFraudInternet: 'Интернет мошенничество',
    formFraudCrypto: 'Криптовалюта обман',
    formFraudEmployment: 'Трудоустройство обман',
    formStepAmount: 'Сумма ущерба',
    formStepAmountDesc: 'Укажите приблизительную сумму потерь',
    formAmountMore: 'и больше',
    formStepTime: 'Когда это произошло?',
    formStepTimeDesc: 'Укажите, как давно произошло мошенничество',
    formTimeMonth: 'Месяц назад',
    formTime2Months: '2 месяца назад',
    formTime3Months: '3 месяца назад',
    formTimeMore: 'Более 3 месяцев',
    formStepDescription: 'Опишите ситуацию',
    formStepDescriptionPlaceholder: 'Расскажите подробно, что произошло...',
    formNext: 'Далее',
    formBack: 'Назад',
    formSubmit: 'Отправить заявку',
    formSubmitting: 'Отправка...',
    formPhoneHint: 'Введите минимум 7 цифр номера телефона',
    formEmailHint: 'Введите корректный email (например: name@mail.ru)',
    formErrorGeneral: 'Произошла ошибка. Проверьте данные и попробуйте ещё раз.',
    formOptional: 'необязательно',
    formSocialProof: '4000+ клиентов уже вернули свои средства',
    formAvgReturn: 'Средний возврат — $12 400',
    formUrgency: 'Бесплатная консультация — осталось',
    formUrgencySlots: 'места на сегодня',
    formSecure: 'Данные зашифрованы и не передаются третьим лицам',
    formExitTitle: 'Не уходите!',
    formExitText: 'Получите бесплатную оценку вашего случая за 2 минуты',
    formExitBtn: 'Вернуться к заявке',
    formSuccessTitle: 'Заявка отправлена!',
    formSuccessText: 'Наш менеджер свяжется с вами в ближайшее время',
    formBackToSite: 'Вернуться на сайт',
    formStep: 'Шаг',
    formOf: 'из',
    successResponseTime: 'Среднее время ответа — 15 минут',
    successConfidential: 'Ваши данные защищены и конфиденциальны',
  },
  
  en: {
    // Header
    about: 'About',
    services: 'Services',
    howWeWork: 'How We Work',
    testimonials: 'Reviews',
    faq: 'FAQ',
    getConsultation: 'Get Consultation',
    
    // Hero
    heroBadge: '15+ years protecting clients\' financial interests worldwide',
    heroTitle: 'We recover your funds from scammers and unscrupulous brokers',
    heroDescription: 'Capitara is a leading international financial company with a global presence. We specialize in recovering funds through banking procedures from scammers, unscrupulous brokers, and investment pyramids. Our team of experts with 15 years of experience successfully returns money to clients in Europe, Asia, America, the Middle East, and Africa. 87% success rate. Payment only for results.',
    freeConsultation: 'Free Consultation',
    ourServices: 'Our Services',
    returnedToClients: 'Returned to clients',
    successfulCases: 'Successful cases',
    countriesWorld: 'Countries',
    
    // About
    aboutTitle: 'About Capitara',
    aboutSubtitle: 'International financial company — fund recovery through banking procedures',
    whoWeAre: 'Who We Are',
    aboutText1: 'Capitara is a leading international financial company specializing in recovering funds through banking procedures from scammers, unscrupulous brokers, and investment pyramids. Our team of experts with 15 years of experience successfully returns money to clients worldwide.',
    aboutText2: 'We work on all continents, helping victims of financial fraud regardless of their location. Our mission is to protect investors\' rights and return what rightfully belongs to them using banking procedures and working with financial regulators. Each client receives personal support in their native language, taking into account local banking regulations and cultural specifics. We understand that financial losses are not only material damage but also emotional stress, which is why we ensure complete confidentiality and professional support at every stage.',
    globalPresence: 'Global Presence',
    globalPresenceText: 'We work with banks and financial regulators worldwide. We recover funds through banking procedures regardless of geography on all continents.',
    regionalExpertise: 'Regional Expertise',
    regionalExpertiseText: 'Specialized teams for each region with deep knowledge of local banking regulations and business practices.',
    multiculturalTeam: 'Multicultural Team',
    multiculturalTeamText: '50+ banking procedure specialists and financial analysts from different countries with experience in international banking operations, fintech, and various financial systems.',
    multiJurisdiction: 'International Banking Experience',
    multiJurisdictionText: 'We work with banking systems worldwide: European, Asian, Middle Eastern, and international financial institutions.',
    individualApproach: 'Individual Approach',
    individualApproachText: 'Each case is unique. We develop a personalized strategy considering cultural, banking, and financial specifics of the client\'s region.',
    provenReputation: 'Proven Reputation',
    provenReputationText: '15 years in the international market, 2000+ successful cases, $10.4M+ returned, positive reviews from clients on all continents.',
    
    // Services
    servicesTitle: 'Our Services',
    servicesSubtitle: 'Comprehensive solutions for recovering your funds',
    brokerRecovery: 'Broker Fund Recovery',
    brokerRecoveryDesc: 'Recovery of deposits from unlicensed and unscrupulous forex and cryptocurrency brokers',
    cryptoFraud: 'Crypto Fraud Recovery',
    cryptoFraudDesc: 'Recovery of funds stolen through fake cryptocurrency platforms and pyramids',
    investmentDisputes: 'Investment Disputes',
    investmentDisputesDesc: 'Resolution of disputes with investment funds and management companies',
    pyramidRecovery: 'Pyramid Scheme Recovery',
    pyramidRecoveryDesc: 'Helping victims of financial pyramids and MLM schemes recover their investments',
    learnMore: 'Learn More',
    
    // Calculator
    calculatorBadge: 'Free Assessment',
    calculatorTitle: 'Fund Recovery Calculator',
    calculatorSubtitle: 'Estimate the probability and amount of your fund recovery in 30 seconds',
    lostAmount: 'Amount of lost funds',
    fraudType: 'Type of fraud',
    forexBroker: 'Forex/CFD Broker',
    cryptoScam: 'Crypto Scam',
    pyramid: 'Financial Pyramid',
    investmentFund: 'Investment Fund',
    other: 'Other',
    whenHappened: 'When did this happen?',
    lessThanWeek: 'Less than a week',
    upToMonth: 'Up to 1 month',
    oneToThreeMonths: '1-3 months',
    threeToSixMonths: '3-6 months',
    sixToTwelveMonths: '6-12 months',
    moreThanYear: 'More than a year',
    hasDocuments: 'Do you have documents/correspondence?',
    yesHave: 'Yes, I have',
    noPartial: 'No / Partial',
    calculate: 'Calculate Recovery',
    calculating: 'Calculating...',
    resultsTitle: 'Assessment Results',
    preliminaryCalc: 'Preliminary calculation',
    successProbability: 'Success probability',
    expectedReturn: 'Expected return',
    returnPeriod: 'Recovery period',
    months: 'months',
    weeks: 'weeks',
    exactConditions: 'Exact conditions are determined after a free consultation with an expert',
    getFreeConsultation: 'Get Free Consultation',
    
    // Offices
    officesBadge: 'Global Presence',
    officesTitle: 'Our Offices Worldwide',
    officesSubtitle: 'We are present on 4 continents for the most effective handling of your case',
    asia: 'Asia',
    middleEast: 'Middle East',
    europe: 'Europe',
    northAmerica: 'North America',
    southAsia: 'South Asia',
    offices: 'Offices',
    continents: 'Continents',
    countriesCoverage: 'Countries coverage',
    support247: 'Support',
    
    // Contact
    contactTitle: 'Get a Free Consultation',
    contactSubtitle: 'Leave a request or contact us via Telegram',
    yourName: 'Name',
    yourNamePlaceholder: 'Your name',
    phone: 'Phone',
    email: 'Email',
    telegram: 'Telegram',
    lossAmount: 'Loss amount (approximately)',
    describeYourSituation: 'Describe your situation',
    describePlaceholder: 'Briefly describe what happened: when, with which company, what amount...',
    sendRequest: 'Send Request',
    sending: 'Sending...',
    contactViaTelegram: 'Contact via Telegram',
    telegramDesc: 'Get a quick response from our experts within 15 minutes. Confidential and convenient.',
    openTelegram: 'Open Telegram',
    workSchedule: 'Work Schedule',
    internationalWork: 'International work 24/7',
    consultation: 'Consultation',
    firstConsultationFree: 'First consultation is free',
    
    // FAQ
    faqTitle: 'Frequently Asked Questions',
    faqSubtitle: 'Answers to popular questions about our services',
    faqQ1: 'What is the probability of fund recovery?',
    faqA1: 'The probability depends on the specific situation. On average, we successfully recover funds in 87% of cases. After a free consultation, we can give an accurate assessment of your chances.',
    faqQ2: 'How long does the recovery process take?',
    faqA2: 'Timelines vary from 1 week to 1 month depending on the complexity of the case, the banking system of the country, and the bank\'s willingness to cooperate. We always inform about progress at every stage.',
    faqQ3: 'What documents are needed to start?',
    faqA3: 'For situation assessment: contracts with the broker/company, transaction confirmations, correspondence, platform screenshots. We will help collect all necessary evidence.',
    faqQ4: 'How is the service cost formed?',
    faqA4: 'We work on a success-fee model - payment only upon successful fund recovery. The commission is 4-15% of the returned amount depending on the complexity of the case.',
    
    // Footer
    footerDesc: 'Professional fund recovery from scammers and unscrupulous brokers. 15+ years of experience, 87% success rate. Operating on 4 continents.',
    company: 'Company',
    contacts: 'Contacts',
    ourOffices: 'Our Offices',
    allRightsReserved: 'All rights reserved.',
    privacyPolicy: 'Privacy Policy',
    termsOfUse: 'Terms of Use',
    returnCalculator: 'Recovery Calculator',

    // Lead Form Page
    formTitle: 'Get Consultation',
    formSubtitle: 'Fill out the form and we will contact you shortly',
    formStepName: 'What is your name?',
    formStepNamePlaceholder: 'Your full name',
    formStepContacts: 'Contact details',
    formStepFraud: 'Type of fraud',
    formStepFraudDesc: 'Select the type of fraud you encountered',
    formFraudInvestment: 'Investments',
    formFraudPyramid: 'Pyramids',
    formFraudInternet: 'Internet fraud',
    formFraudCrypto: 'Cryptocurrency scam',
    formFraudEmployment: 'Employment fraud',
    formStepAmount: 'Damage amount',
    formStepAmountDesc: 'Specify the approximate amount of losses',
    formAmountMore: 'and more',
    formStepTime: 'When did this happen?',
    formStepTimeDesc: 'Specify how long ago the fraud occurred',
    formTimeMonth: 'A month ago',
    formTime2Months: '2 months ago',
    formTime3Months: '3 months ago',
    formTimeMore: 'More than 3 months',
    formStepDescription: 'Describe the situation',
    formStepDescriptionPlaceholder: 'Tell us in detail what happened...',
    formNext: 'Next',
    formBack: 'Back',
    formSubmit: 'Submit request',
    formSubmitting: 'Submitting...',
    formPhoneHint: 'Enter at least 7 digits of your phone number',
    formEmailHint: 'Enter a valid email (e.g. name@mail.com)',
    formErrorGeneral: 'An error occurred. Please check your data and try again.',
    formOptional: 'optional',
    formSocialProof: '4000+ clients have already recovered their funds',
    formAvgReturn: 'Average recovery — $12,400',
    formUrgency: 'Free consultation — only',
    formUrgencySlots: 'spots left today',
    formSecure: 'Your data is encrypted and never shared with third parties',
    formExitTitle: "Don't leave!",
    formExitText: 'Get a free assessment of your case in 2 minutes',
    formExitBtn: 'Return to application',
    formSuccessTitle: 'Request sent!',
    formSuccessText: 'Our manager will contact you shortly',
    formBackToSite: 'Back to website',
    formStep: 'Step',
    formOf: 'of',
    successResponseTime: 'Average response time — 15 minutes',
    successConfidential: 'Your data is protected and confidential',
  },
  
  ar: {
    // Header
    about: 'معلومات عنا',
    services: 'خدمات',
    howWeWork: 'كيف نعمل',
    testimonials: 'آراء',
    faq: 'أسئلة',
    getConsultation: 'احصل على استشارة',
    
    // Hero
    heroBadge: '+15 عاماً نحمي المصالح المالية للعملاء حول العالم',
    heroTitle: 'نسترد أموالك من المحتالين والوسطاء غير الأمناء',
    heroDescription: 'Capitara هي شركة مالية دولية رائدة ذات حضور عالمي. نحن متخصصون في استرداد الأموال من خلال الإجراءات المصرفية من المحتالين والوسطاء غير الأمناء والأهرامات الاستثمارية. فريقنا من الخبراء مع 15 عاماً من الخبرة ينجح في إعادة الأموال للعملاء في أوروبا وآسيا وأمريكا والشرق الأوسط وأفريقيا. نسبة نجاح 87%. الدفع فقط مقابل النتائج.',
    freeConsultation: 'استشارة مجانية',
    ourServices: 'خدماتنا',
    returnedToClients: 'تم إرجاعها للعملاء',
    successfulCases: 'حالات ناجحة',
    countriesWorld: 'دولة',
    
    // About
    aboutTitle: 'عن Capitara',
    aboutSubtitle: 'شركة مالية دولية — استرداد الأموال من خلال الإجراءات المصرفية',
    whoWeAre: 'من نحن',
    aboutText1: 'Capitara هي شركة مالية دولية رائدة متخصصة في استرداد الأموال من خلال الإجراءات المصرفية من المحتالين والوسطاء غير الأمناء والأهرامات الاستثمارية. فريقنا من الخبراء مع 15 عاماً من الخبرة ينجح في إعادة الأموال للعملاء حول العالم.',
    aboutText2: 'نعمل في جميع القارات، نساعد ضحايا الاحتيال المالي بغض النظر عن موقعهم. مهمتنا هي حماية حقوق المستثمرين وإعادة ما يخصهم بحق باستخدام الإجراءات المصرفية والعمل مع الجهات الرقابية المالية.',
    globalPresence: 'الحضور العالمي',
    globalPresenceText: 'نعمل مع البنوك والجهات الرقابية المالية في جميع أنحاء العالم. نسترد الأموال من خلال الإجراءات المصرفية بغض النظر عن الجغرافيا.',
    regionalExpertise: 'الخبرة الإقليمية',
    regionalExpertiseText: 'فرق متخصصة لكل منطقة مع معرفة عميقة بالتشريعات المحلية.',
    multiculturalTeam: 'فريق متعدد الثقافات',
    multiculturalTeamText: '+50 متخصص في الإجراءات المصرفية ومحلل مالي من دول مختلفة.',
    multiJurisdiction: 'خبرة مصرفية دولية',
    multiJurisdictionText: 'نعمل مع أنظمة مصرفية مختلفة: الأوروبية والآسيوية والشرق أوسطية والمؤسسات المالية الدولية.',
    individualApproach: 'نهج فردي',
    individualApproachText: 'كل حالة فريدة. نطور استراتيجية شخصية.',
    provenReputation: 'سمعة مثبتة',
    provenReputationText: '15 عاماً في السوق الدولي، +2000 حالة ناجحة، +$10.4M تم إرجاعها.',
    
    // Services
    servicesTitle: 'خدماتنا',
    servicesSubtitle: 'حلول شاملة لاسترداد أموالك',
    brokerRecovery: 'استرداد أموال الوسطاء',
    brokerRecoveryDesc: 'استرداد الودائع من وسطاء الفوركس والعملات المشفرة غير المرخصين',
    cryptoFraud: 'مكافحة احتيال العملات المشفرة',
    cryptoFraudDesc: 'استرداد الأموال المسروقة عبر منصات العملات المشفرة المزيفة',
    investmentDisputes: 'النزاعات الاستثمارية',
    investmentDisputesDesc: 'حل النزاعات مع صناديق الاستثمار وشركات الإدارة',
    pyramidRecovery: 'استرداد من الأهرامات المالية',
    pyramidRecoveryDesc: 'مساعدة ضحايا الأهرامات المالية في استرداد استثماراتهم',
    learnMore: 'المزيد',
    
    // Calculator
    calculatorBadge: 'تقييم مجاني',
    calculatorTitle: 'حاسبة استرداد الأموال',
    calculatorSubtitle: 'قيّم احتمالية ومبلغ استرداد أموالك في 30 ثانية',
    lostAmount: 'مبلغ الأموال المفقودة',
    fraudType: 'نوع الاحتيال',
    forexBroker: 'وسيط فوركس/CFD',
    cryptoScam: 'احتيال العملات المشفرة',
    pyramid: 'هرم مالي',
    investmentFund: 'صندوق استثمار',
    other: 'أخرى',
    whenHappened: 'متى حدث هذا؟',
    lessThanWeek: 'أقل من أسبوع',
    upToMonth: 'حتى شهر واحد',
    oneToThreeMonths: '1-3 أشهر',
    threeToSixMonths: '3-6 أشهر',
    sixToTwelveMonths: '6-12 شهر',
    moreThanYear: 'أكثر من سنة',
    hasDocuments: 'هل لديك مستندات/مراسلات؟',
    yesHave: 'نعم، لدي',
    noPartial: 'لا / جزئياً',
    calculate: 'احسب الاسترداد',
    calculating: 'جاري الحساب...',
    resultsTitle: 'نتائج التقييم',
    preliminaryCalc: 'حساب أولي',
    successProbability: 'احتمالية النجاح',
    expectedReturn: 'العائد المتوقع',
    returnPeriod: 'فترة الاسترداد',
    months: 'أشهر',
    weeks: 'أسابيع',
    exactConditions: 'يتم تحديد الشروط الدقيقة بعد استشارة مجانية مع خبير',
    getFreeConsultation: 'احصل على استشارة مجانية',
    
    // Offices
    officesBadge: 'الحضور العالمي',
    officesTitle: 'مكاتبنا حول العالم',
    officesSubtitle: 'نحن موجودون في 4 قارات للتعامل الأكثر فعالية مع قضيتك',
    asia: 'آسيا',
    middleEast: 'الشرق الأوسط',
    europe: 'أوروبا',
    northAmerica: 'أمريكا الشمالية',
    southAsia: 'جنوب آسيا',
    offices: 'مكاتب',
    continents: 'قارات',
    countriesCoverage: 'تغطية الدول',
    support247: 'الدعم',
    
    // Contact
    contactTitle: 'احصل على استشارة مجانية',
    contactSubtitle: 'اترك طلباً أو تواصل معنا عبر تيليجرام',
    yourName: 'الاسم',
    yourNamePlaceholder: 'اسمك',
    phone: 'الهاتف',
    email: 'البريد الإلكتروني',
    telegram: 'تيليجرام',
    lossAmount: 'مبلغ الخسارة (تقريباً)',
    describeYourSituation: 'صف موقفك',
    describePlaceholder: 'صف باختصار ما حدث: متى، مع أي شركة، ما المبلغ...',
    sendRequest: 'إرسال الطلب',
    sending: 'جاري الإرسال...',
    contactViaTelegram: 'تواصل عبر تيليجرام',
    telegramDesc: 'احصل على رد سريع من خبرائنا خلال 15 دقيقة. سري ومريح.',
    openTelegram: 'فتح تيليجرام',
    workSchedule: 'جدول العمل',
    internationalWork: 'عمل دولي 24/7',
    consultation: 'استشارة',
    firstConsultationFree: 'الاستشارة الأولى مجانية',
    
    // FAQ
    faqTitle: 'الأسئلة الشائعة',
    faqSubtitle: 'إجابات على الأسئلة الشائعة حول خدماتنا',
    faqQ1: 'ما هي احتمالية استرداد الأموال؟',
    faqA1: 'تعتمد الاحتمالية على الموقف المحدد. في المتوسط، ننجح في استرداد الأموال في 87% من الحالات.',
    faqQ2: 'كم من الوقت تستغرق عملية الاسترداد؟',
    faqA2: 'تتراوح المدة من أسبوع إلى شهر حسب تعقيد القضية.',
    faqQ3: 'ما المستندات المطلوبة للبدء؟',
    faqA3: 'العقود مع الوسيط/الشركة، تأكيدات المعاملات، المراسلات، لقطات شاشة المنصة.',
    faqQ4: 'كيف يتم تحديد تكلفة الخدمة؟',
    faqA4: 'نعمل بنموذج رسوم النجاح - الدفع فقط عند استرداد الأموال بنجاح. العمولة 4-15%.',
    
    // Footer
    footerDesc: 'استرداد أموال احترافي من المحتالين والوسطاء غير الأمناء. +15 عاماً من الخبرة، نسبة نجاح 87%.',
    company: 'الشركة',
    contacts: 'جهات الاتصال',
    ourOffices: 'مكاتبنا',
    allRightsReserved: 'جميع الحقوق محفوظة.',
    privacyPolicy: 'سياسة الخصوصية',
    termsOfUse: 'شروط الاستخدام',
    returnCalculator: 'حاسبة الاسترداد',

    // Lead Form Page
    formTitle: 'احصل على استشارة',
    formSubtitle: 'املأ النموذج وسنتصل بك في أقرب وقت',
    formStepName: 'ما اسمك؟',
    formStepNamePlaceholder: 'اسمك الكامل',
    formStepContacts: 'بيانات الاتصال',
    formStepFraud: 'نوع الاحتيال',
    formStepFraudDesc: 'اختر نوع الاحتيال الذي تعرضت له',
    formFraudInvestment: 'استثمارات',
    formFraudPyramid: 'أهرامات',
    formFraudInternet: 'احتيال إنترنت',
    formFraudCrypto: 'احتيال العملات المشفرة',
    formFraudEmployment: 'احتيال التوظيف',
    formStepAmount: 'مبلغ الضرر',
    formStepAmountDesc: 'حدد المبلغ التقريبي للخسائر',
    formAmountMore: 'وأكثر',
    formStepTime: 'متى حدث هذا؟',
    formStepTimeDesc: 'حدد منذ متى حدث الاحتيال',
    formTimeMonth: 'منذ شهر',
    formTime2Months: 'منذ شهرين',
    formTime3Months: 'منذ 3 أشهر',
    formTimeMore: 'أكثر من 3 أشهر',
    formStepDescription: 'صف الموقف',
    formStepDescriptionPlaceholder: 'أخبرنا بالتفصيل ماذا حدث...',
    formNext: 'التالي',
    formBack: 'السابق',
    formSubmit: 'إرسال الطلب',
    formSubmitting: 'جاري الإرسال...',
    formPhoneHint: 'أدخل 7 أرقام على الأقل من رقم هاتفك',
    formEmailHint: 'أدخل بريدًا إلكترونيًا صالحًا (مثال: name@mail.com)',
    formErrorGeneral: 'حدث خطأ. يرجى التحقق من البيانات والمحاولة مرة أخرى.',
    formOptional: 'اختياري',
    formSocialProof: '+4000 عميل استعادوا أموالهم بالفعل',
    formAvgReturn: 'متوسط الاسترداد — 12,400$',
    formUrgency: 'استشارة مجانية — بقي',
    formUrgencySlots: 'أماكن اليوم',
    formSecure: 'بياناتك مشفرة ولا يتم مشاركتها مع أطراف ثالثة',
    formExitTitle: 'لا تغادر!',
    formExitText: 'احصل على تقييم مجاني لقضيتك في دقيقتين',
    formExitBtn: 'العودة إلى الطلب',
    formSuccessTitle: 'تم إرسال الطلب!',
    formSuccessText: 'سيتصل بك مديرنا في أقرب وقت',
    formBackToSite: 'العودة إلى الموقع',
    formStep: 'خطوة',
    formOf: 'من',
    successResponseTime: 'متوسط وقت الاستجابة — 15 دقيقة',
    successConfidential: 'بياناتك محمية وسرية',
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [currentLang, setCurrentLang] = useState('ru');

  useEffect(() => {
    const saved = localStorage.getItem('selectedLang');
    if (saved && translations[saved]) {
      setCurrentLang(saved);
    }
  }, []);

  const changeLang = (lang) => {
    setCurrentLang(lang);
    localStorage.setItem('selectedLang', lang);
  };

  const t = translations[currentLang] || translations.ru;
  const isRTL = currentLang === 'ar';

  return (
    <LanguageContext.Provider value={{ currentLang, changeLang, t, isRTL }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
